
// Import vendor modules.
import Alpine from "@alpinejs/csp";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

Alpine.data( "h5aqil_Emojis", Emojis );

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

function Emojis() {

	return {
		emitEmoji,
	};

	// ---
	// PUBLIC METHODS.
	// ---

	/**
	* I emit the emoji event associated with the target button.
	*/
	function emitEmoji( emoji ) {

		this.$dispatch(
			"emoji",
			{
				emoji,
			}
		);

	}

}
